import { Row, Col, Modal, Form, Input, Select } from "antd";
import "react-phone-input-2/lib/style.css";
import React, { useState, useEffect } from "react";
import useRequest from "../../hooks/useRequest";
import { ShowToast, Severty } from "../../helper/toast";
import apiPath from "../../constants/apiPath";
import lang from "../../helper/lang";
import { CloseOutlined, CheckOutlined } from "@ant-design/icons";

const AddFrom = ({
  path,
  sectionName,
  show,
  hide,
  data,
  refresh,
  isUpdate,
  setIsUpdate,
}) => {
  const [form] = Form.useForm();
  const { request } = useRequest();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!data) return;

    form.setFieldsValue({
      ...data,
      action: data?.action,
      points: data?.points,
    });
  }, [data]);

  const onCreate = (values) => {
    const { action, points } = values;

    const payload = {
      action,
      points,
    };

    setLoading(true);
    if (isUpdate) {
      request({
        url: `${apiPath.updatePointRule}/${data._id}`,
        method: "PUT",
        data: payload,
        onSuccess: (data) => {
          setLoading(false);
          if (data.status) {
            ShowToast(data.message, Severty.SUCCESS);
            hide();
            refresh();
          } else {
            ShowToast(data.message, Severty.ERROR);
          }
          setIsUpdate(false);
        },
        onError: (error) => {
          ShowToast(error.response.data.message, Severty.ERROR);
          setLoading(false);
        },
      });
    } else {
      request({
        url: `${apiPath.addPointRule}`,
        method: "POST",
        data: payload,
        onSuccess: (data) => {
          setLoading(false);
          if (data.status) {
            ShowToast(data.message, Severty.SUCCESS);
            hide();
            refresh();
          } else {
            ShowToast(data.message, Severty.ERROR);
          }
        },
        onError: (error) => {
          ShowToast(error.response.data.message, Severty.ERROR);
          setLoading(false);
        },
      });
    }
  };

  return (
    <Modal
      width={600}
      open={show}
      title={`${
        data
          ? lang("Update") + " " + sectionName
          : lang("Add") + " " + lang("New") + " " + sectionName
      }`}
      okText={`${data ? lang("Update") : lang("Add")}`}
      cancelText={
        <>
          <CloseOutlined style={{ marginRight: "8px" }} />
          {lang("Cancel")}
        </>
      }
      onCancel={hide}
      okButtonProps={{
        form: "create",
        htmlType: "submit",
        loading: loading,
        icon: <CheckOutlined />,
      }}
    >
      <Form
        id="create"
        form={form}
        initialValues={{ deal_in: "Products" }}
        onFinish={onCreate}
        layout="vertical"
      >
        <Row gutter={[16, 16]}>
          <Col span={24} lg={24}>
            <Form.Item
              className="mb-1"
              label="Action"
              name="action"
              rules={[
                {
                  required: true,
                  message: "Please select an action",
                },
              ]}
            >
              <Select placeholder="Select action">
                <Select.Option value="REGISTRATION">
                  Register user
                </Select.Option>

                <Select.Option value="PROFILE_COMPLETE">
                  Complete Profile
                </Select.Option>

                <Select.Option value="UPLOAD_POST">
                  Upload Post / Video
                </Select.Option>

                <Select.Option value="TAG_POST">
                  Get Tagged in Post
                </Select.Option>

                <Select.Option value="LIKE_CONTENT">Like Content</Select.Option>

                <Select.Option value="COMMENT_CONTENT">
                  Comment on Content
                </Select.Option>

                <Select.Option value="SHARE_CONTENT">
                  Share Content
                </Select.Option>

                <Select.Option value="JOIN_GROUP">
                  Join Group or Team
                </Select.Option>
              </Select>
            </Form.Item>
          </Col>
          <Col span={24} lg={24}>
            <Form.Item
              className="mb-1"
              label="Point"
              name="points"
              rules={[
                {
                  required: true,
                  message: "Please Enter point number",
                },
              ]}
            >
              <Input type="number" min={1} placeholder="Enter point  " />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default AddFrom;
